export enum EPromoType {
    topBanner = 'topBanner',
    whatsNew = 'whatsNew',
}

export interface IBaseData {
    promoId: string;
    onShow();
    onClose();
    onClick();
}

export interface ITopBannerData extends IBaseData {
    html?: string;
    height?: number;
    closeColor?: string;
}

export interface IWhatsNewData extends IBaseData {
    title: string;
    text: string;
    imageUrl: string;
    date?: number;
    primaryButtonText: string;
    primaryButtonHref: string;
    secondaryButtonText: string;
    secondaryButtonHref: string;
    onSecondary();
}

type IPromoDataBanner = {
    type: EPromoType.topBanner;
    priority?: number;
    data: ITopBannerData;
};

type IPromoDataWhatsNew = {
    type: EPromoType.whatsNew;
    priority?: number;
    data: IWhatsNewData;
};

export type IPromoData = IPromoDataBanner | IPromoDataWhatsNew;

export interface IPromoState {
    lastPromoShownTimestamp?: Date;
    queue: IPromoData[];
    currentPromo: IPromoData | null;
}
